export class HelperCctInternet {

  static commonApiUrl: string;
  static publicApiUrl: string;
  static prospectusPublicApiUrl: string;

  static setPaths = (basePath: string) => {
    HelperCctInternet.commonApiUrl = basePath + 'api/CommonNg';
    HelperCctInternet.publicApiUrl = basePath + 'api/PublicNg';
    HelperCctInternet.prospectusPublicApiUrl = basePath + 'api/ProspectusPublicNg';
  }
}
